import { Typography } from '@mui/material';
import { Svgs } from '../../../assets/svg';
import { Column, Row, Spacer } from '../../../components';
import { PaidByEnum } from '../../../models/LicenseData';

interface LearnMoreDrawerHeaderProps {
  paidBy: string;
  pricebookName: string;
  logo: string;
}

const LearnMoreDrawerHeader: React.FC<LearnMoreDrawerHeaderProps> = ({
  paidBy,
  pricebookName,
  logo,
}) => {
  return (
    <Row>
      <Column style={{ width: '90%' }}>
        <Row style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          {paidBy === PaidByEnum.User ? <Svgs.IconMemberPaysLarge /> : <Svgs.IconOrgPaysLarge />}
          <Spacer width='xxs' />
          <Typography color='secondary' variant='p12SemiBold'>
            {paidBy === PaidByEnum.User ? 'Member pays' : 'Organization pays'}
          </Typography>
        </Row>

        <Spacer height='xxs' />
        <Typography color='secondary' variant='p30Light'>
          {pricebookName}
        </Typography>
        <Spacer height='xxs' />
      </Column>
      <img src={logo} alt='logo' style={{ height: '40px' }} />
    </Row>
  );
};

export default LearnMoreDrawerHeader;
